import { Box, Flex, Progress, Text, VStack } from "@chakra-ui/react"
import Card from "components/Card/Card"
import CardBody from "components/Card/CardBody"
import CardHeader from "components/Card/CardHeader"
import { calculatePercentage } from "functions/percentage"

interface Props {
	title: string,
	value: number,
	total: number,
	color: string
}

const BarValue = ({ title, value, total, color }: Props) => {
	return (
		<Box w="full">
			<Flex w="full" justifyContent="space-between">
				<Text fontSize="md">{title}</Text>
				<Text fontSize="md">{calculatePercentage(value, total)}%</Text>
			</Flex>
			<Progress w="full" colorScheme={color} size='md' value={calculatePercentage(value, total)} />
		</Box>
	)
}

const SchedulesTotal = () => {
	return (
		<Card>
			<CardHeader>
				<Text fontSize="lg">Resumo de Compromissos</Text>
			</CardHeader>
			<CardBody>
				<Box w="full">
					<VStack spacing={4}>
						<BarValue
							title="Comparecimentos"
							value={68}
							total={100}
							color="green"
						/>
						<BarValue
							title="Reagendamentos"
							value={21}
							total={100}
							color="blue"
						/>
						<BarValue
							title="Cancelamentos"
							value={11}
							total={100}
							color="red"
						/>
					</VStack>
				</Box>
			</CardBody>
		</Card>
	)
}

export default SchedulesTotal
